export default __webpack_public_path__ + "static/media/metamask.b9f67a19.png";